/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'
import ThematicCategories from '~/components/thematic-categories'

/**
 * Core scripts.
 */
import EventBus from '~/core/event-bus'
import Query from '~/core/query'

/**
 * Global Basis functions.
 */
window.basis = window.basis || {}
window.basis.EventBus = EventBus()
window.basis.Query = (query) => Query(query)

document.addEventListener('DOMContentLoaded', () => {
  ThematicCategories().init()
})
